import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import './i18n/config';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
